export enum Breakpoints {
  maxMobileWidth = 520,
  maxTabletWidth = 900
}
